import type { ContextMenuProps } from '../../legacy/components/FileBrowser';
import { ItemContextMenu } from '../../legacy/components/sections/ContextMenu/ItemContextMenu';
import { PublicFolderActions } from './actions/PublicFolderActions';
import { usePublicActions } from './actions/usePublicActions';

export function PublicFolderItemContextMenu({
    anchorRef,
    isOpen,
    customPassword,
    position,
    open,
    close,
}: ContextMenuProps & { customPassword: string | undefined }) {
    const { modals, handlePreview, handleDownload, handleDetails, handleRename, handleDelete, handleOpenDocsOrSheets } =
        usePublicActions();
    return (
        <>
            <ItemContextMenu isOpen={isOpen} open={open} close={close} position={position} anchorRef={anchorRef}>
                <PublicFolderActions
                    onPreview={handlePreview}
                    onDetails={handleDetails}
                    onDownload={handleDownload}
                    onDelete={handleDelete}
                    onRename={handleRename}
                    onOpenDocsOrSheets={(uid, openInDocs) => handleOpenDocsOrSheets(uid, openInDocs, customPassword)}
                    close={close}
                    buttonType="contextMenu"
                />
            </ItemContextMenu>
            {modals.previewModal}
            {modals.detailsModal}
            {modals.confirmModal}
            {modals.renameModal}
        </>
    );
}
